<es-modal
  (esDismiss)="emitClose($event)"
  [closeText]="'Close' | translate"
  class="switch-profile-modal"
>
  <p class="switch-profile-modal__text" translate>
    Are you sure you want to switch profiles?
  </p>

  <div class="switch-profile-modal__actions">
    <button class="switch-profile-modal__action regressive" (click)="emitClose($event)" translate>
      Cancel
    </button>

    <button
      class="switch-profile-modal__action action"
      (click)="emitSwitchProfile($event)"
      translate
    >
      Switch
    </button>
  </div>
</es-modal>
